import React from "react";
import CardClass from "../../../CardClass";
import EmptyState from "../../../EmptyState";
import MUIButton from "@mui/material/Button";
import MUIFormControlLabel from "@mui/material/FormControlLabel";
import MUISwitch from "@mui/material/Switch";
import MUIIconButton from "@mui/material/IconButton";
import MUIAddIcon from "@mui/icons-material/Add";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUIGrid from "@mui/material/Grid2";
import DialogSearch from "../../../Dialog/DialogSearch";
import Tile from "../../../Tile";

export default class CardAdminQueueFilterPendingPreauthCompleted extends CardClass {
  constructor(props) {
    super(props);

    this.state.completedDialogOpen = false;
  }

  /**
   * Render the content of the card.
   */
  renderContent() {
    const handleRemove = (completed) => {
      const filter = this.props.queue.filter;
      if (!filter["pending_preauth.completed"]?.properties?.value) {
        return;
      }
      filter["pending_preauth.completed"].properties.value = filter[
        "pending_preauth.completed"
      ].properties.value.filter((entry) => entry !== completed);
      if (filter["pending_preauth.completed"].properties.value.length === 0) {
        delete filter["pending_preauth.completed"];
      }

      this.props.onChange({
        filter: filter,
      });
    };

    const values =
      this.props.queue?.filter?.["pending_preauth.completed"]?.properties
        ?.value || [];

    const excludeChecked =
      this.props.queue?.filter?.["pending_preauth.completed"]?.properties
        ?.operator === "not in";

    const handleExcludeToggle = (event) => {
      const filter = this.props.queue.filter;
      filter["pending_preauth.completed"].properties.operator = event.target
        .checked
        ? "not in"
        : "in";

      this.props.onChange({
        filter: filter,
      });
    };

    if (values.length > 0) {
      return (
        <>
          <MUIFormControlLabel
            sx={{ marginLeft: 0 }}
            control={
              <MUISwitch
                color="error"
                checked={excludeChecked}
                onChange={handleExcludeToggle}
              />
            }
            label="Exclude"
          />
          <MUIGrid container spacing={2}>
            {values.map((completed) => {
              return (
                <MUIGrid
                  key={completed}
                  size={{
                    xs: 12,
                    sm: 6,
                    md: 4,
                  }}
                >
                  <Tile
                    title={completed === 1 ? "Completed" : "Not Completed"}
                    avatarString={
                      completed === 1 ? "Completed" : "Not Completed"
                    }
                    iconButtons={[
                      <MUIIconButton onClick={() => handleRemove(completed)}>
                        <MUIDeleteIcon />
                      </MUIIconButton>,
                    ]}
                  />
                </MUIGrid>
              );
            })}
            {this.renderDialog()}
          </MUIGrid>
        </>
      );
    } else {
      return (
        <>
          <EmptyState
            line1="Not Configured"
            line2="Showing all Completed States"
          />
          {this.renderDialog()}
        </>
      );
    }
  }

  /**
   * Renders a search dialog of Issue Statuses
   */
  renderDialog() {
    const handleAdd = (completed) => {
      const filter = (this.props.queue && this.props.queue.filter) || {};
      if (!filter["pending_preauth.completed"]) {
        filter["pending_preauth.completed"] = {
          type: "set",
          properties: {
            operator: "in",
            value: [],
          },
        };
      }
      filter["pending_preauth.completed"].properties.value = [
        ...new Set([
          ...(filter["pending_preauth.completed"].properties.value || []),
          completed.value,
        ]),
      ];

      this.props.onChange({
        filter: filter,
      });
    };

    return (
      <DialogSearch
        data={[
          { value: 1, name: "Completed" },
          { value: 0, name: "Not Completed" },
        ]}
        open={this.state.completedDialogOpen}
        onClose={() => this.setState({ completedDialogOpen: false })}
        onSelect={handleAdd}
      />
    );
  }

  /**
   * Renders add Issue Status button
   */
  getActions() {
    const handleAdd = () => {
      this.setState({
        completedDialogOpen: true,
      });
    };

    const buttonItems = [
      <MUIButton
        component="label"
        variant="outlined"
        startIcon={<MUIAddIcon />}
        onClick={handleAdd}
      >
        Add Completed Status
      </MUIButton>,
    ];

    return buttonItems;
  }

  /**
   * @returns {string} The title of the card.
   */
  getTitle() {
    return "Filter: Pending Preauth > Completed";
  }
}
